import { Formik, FormikValues, FieldValidator, FieldProps } from 'formik';
import { Spacer } from '../Spacer';
import React, { FC } from 'react';
import { useRequest } from '../../utils/requests';
import {
  FormHero,
  Form as FormikForm,
  AuthorPostSubmission,
  TextField,
  SubmitButton,
  FootNote,
  fieldStyles,
} from '../Form';
import { AirtableRemoteWorkAuthors } from '../../../graphql-types';
import styled from 'styled-components';
import { FieldInputProps } from 'formik/dist/types';
import { SittingPeeps } from '../SittingPeeps';
import { media } from '../../utils/styles';

export type FormField = {
  name: string;
  label: string;
  type: string;
  initialValue: string;
  placeholder?: string;
  validate?: FieldValidator;
};

export type PageFormProps = {
  title: string;
  subtitle?: string;
  author: AirtableRemoteWorkAuthors;
};

const required = (value: string) => (value ? undefined : 'Required');

const FormWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Form = styled(FormikForm)`
  width: 100%;
  display: flex;
  ${media.mobile`flex-direction: column;`}
`;

const FormPeeps = styled(SittingPeeps)`
  height: auto;
  flex: 1 0 35%;
  ${media.mobileL`display: none;`}
`;

const Question = styled.textarea<FieldInputProps<any> & { isValid: boolean }>`
  ${fieldStyles};
`;

export const AuthorForm: FC<PageFormProps> = ({ author, title, subtitle }) => {
  const [subscribe, { data, error, loading }, reset] = useRequest<{ count: number; goal: number }>('question');

  const onSubmit = async (values: FormikValues) => {
    await subscribe({ ...values, author: author?.recordId ? [author?.recordId] : '' });
  };
  return (
    <FormHero title={title} subtitle={subtitle}>
      <Formik
        validateOnMount={true}
        onSubmit={async (values, { resetForm }) => {
          await onSubmit(values);
          resetForm();
        }}
        initialValues={{
          email: '',
          question: '',
        }}
      >
        <>
          <AuthorPostSubmission success={data} error={error} />
          <Form onChange={reset}>
            <FormWrap>
              <TextField
                id="email-input"
                name="email"
                label="Email"
                type="email"
                placeholder="Type your email here..."
                validate={required}
              />
              <Spacer />
              <TextField name="question" label="Question" validate={required}>
                {({ field, form: { isValid } }: FieldProps) => (
                  <Question
                    name="question"
                    cols={30}
                    rows={5}
                    placeholder="How do you do xyz?"
                    isValid={isValid}
                    {...field}
                  />
                )}
              </TextField>
              <Spacer />
              <SubmitButton loading={loading}>Submit</SubmitButton>
            </FormWrap>
            <FormPeeps />
          </Form>
        </>
      </Formik>
      <FootNote />
    </FormHero>
  );
};
